module.exports = "/_next/static/images/CompleteDataCollected@2x-e657883afacf3293b7e0cdef507743ed.webp";